import { Padding, LegendSymbol } from 'components/base/layout-components';
import React from 'react';
import LegendItem from './LegendItem';

const CustomPieTooltip = ({ data }) => {
  return (
    <Padding padding='x-x-small' b='no-space'>
      {data.map(({ name, value, color }, idx) => {
        return (
          <>
            <LegendItem
              key={idx}
              icon={<LegendSymbol backgroundColor={color} />}
              sum={value ? `${value}%` : '-'}
              name={name}
              isTooltip={true}
              isHorizontalView={false}
            />
          </>
        );
      })}
    </Padding>
  );
};

export default CustomPieTooltip;
